import * as React from 'react';
import './Activity.less';
import { LocalizeContextProps, withLocalize, Translate } from 'react-localize-redux';
import bindAllOfThis from 'src/utils/BindThisHelper';
import ActivityApiController from 'src/api/ActivityApiController';
import StudentActivityDTO from 'src/models/activity/StudentActivityDTO';
import StudentActivitySummaryDTO from 'src/models/activity/StudentActivitySummaryDTO';
import { Game } from "src/constants/Games";
import AudioPlayer from "src/components/common/AudioPlayer";
import AudioTranslations from "src/constants/AudioTranslations";
import { Track } from 'src/providers/TelemetryService';

interface ActivitySummaryComponentProps extends LocalizeContextProps {
    activity: StudentActivityDTO;
    currentGame: Game;
    onNext: () => void;
    onBack: () => void;
    summary: StudentActivitySummaryDTO;
}

class ActivitySummaryComponent extends React.Component<ActivitySummaryComponentProps> {
    constructor(props: ActivitySummaryComponentProps) {
        super(props);
        bindAllOfThis(this, ActivitySummaryComponent.prototype);
    }

    componentDidMount() {
        this.reloadComponent(this.props);
        document.addEventListener("keydown", this.handleKeyPress, false);
        const { activity, currentGame } = this.props;
        const activityType = activity.isSurvey ? 'Survey' : 'Quiz';
        const activityName = `${currentGame.name}_${currentGame.grade.shortName}${currentGame.planet.name}_${activityType}`;
        Track.Activity(activity.isSurvey ? 'SURVEY' : 'QUIZ', activityName, activity.id, 'SUMMARY', 1);
    }

    componentWillUnmount() {
        // Remove the event when we change pages
        document.removeEventListener("keydown", this.handleKeyPress, false);
    }

    handleKeyPress(event): void {
        if (event.key === "ArrowRight") {
            if (this.hasNextButton()) {
                this.props.onNext();
            }
        }
        else if (event.key === "ArrowLeft") {
            if (this.hasBackButton()) {
                this.props.onBack();
            }
        }
    }

    hasNextButton(): boolean {
        return true;
    }

    hasBackButton(): boolean {
        return true;
    }

    componentWillReceiveProps(nextProps: ActivitySummaryComponentProps) {
        if ((this.props.activity == null && nextProps.activity != null)
            || (this.props.activity.id !== nextProps.activity.id)
            || this.props.summary.text !== nextProps.summary.text) {
            this.reloadComponent(nextProps);
        }
    }

    private reloadComponent(props: ActivitySummaryComponentProps) {
        if (props.summary == null || props.summary.text == null || props.summary.text.length < 1) {
            this.props.onNext();
        }
    }

    render() {
        if (this.props.activity == null || this.props.activity.id < 1) {
            return null;
        }

        let audioTrans = AudioTranslations.FindByKeyAndLanguage(this.props.summary.audioKey, this.props.activeLanguage.code);

        return [
            <AudioPlayer
                audioURL={audioTrans.url}
                isPlaying={true} />,
            <h2><Translate id="student.activity.summary" /></h2>,
            <p> <Translate id="student.activity.score" />{this.props.summary.score}</p >,
            <p>{this.props.summary.text || ""}</p>,
        ];
    }
}

export default withLocalize(ActivitySummaryComponent);



// WEBPACK FOOTER //
// ./src/components/student/ActivitySummary.tsx